import React from 'react';
import { SvgIcon } from '@mui/material';

const CustomArrowIcon = ({ direction = 'up', ...props }) => (
    <SvgIcon {...props} viewBox="0 0 24 24" sx={{
        verticalAlign: 'middle',
        fontSize: props.fontSize || 'inherit',  // Ensure fontSize is passed or inherited
    }}>
        {direction === 'up' ? (
            // Upward arrow
            <path d="M6 14l6-6 6 6" fill="none" stroke="currentColor" strokeWidth="1" />
        ) : direction === 'down' ? (
            // Downward arrow
            <path d="M6 10l6 6 6-6" fill="none" stroke="currentColor" strokeWidth="1" />
        ) : (
            // Flat arrow (no sorting)
            <path d="M6 12h12" fill="none" stroke="currentColor" strokeWidth="1" />
        )}
    </SvgIcon>
);

export default CustomArrowIcon;
